
import { url } from '@tencent/wphk-base-utils';
export enum UrlParamKey {
  // 注意：不从url链接里取merchantId，应从useMerchantInfo().merchantId中取
  // merchantId = 'merchantId',
  // 注意：不建议从url链接取spId，应从useMerchantInfo().spId中取
  spId = 'spId',
  adtag = 'adtag',
  discountCode = 'discountCode', // 优惠码参数
  eCashCp = 'eCashCp', // 是否展示现金券模块，为1则展示
  shareCouponCode= 'shareCouponCode', // 分享券分享码参数
  // 以下字段用于埋点
  sceneId = 'sceneId', // 打开场景值
  area = 'area', // 地区标识
  // 用于非香港钱包用户访问跳转标记，上报会在拓展参数中加上，看login.ts
  isNotHkUser = 'isNotHkUser',
  // 跳转目标页
  page ='page',
  /** 优惠券Id */
  couponId = 'couponId',

  /**
   * 链接标记
   * i.e. fromtag=share
   */
  fromtag = 'fromtag',

  /**
   * 物料平台一物一码
   * 当用户通过物料扫码进来时，会携带mtn参数，考虑到不同用法，同时提供大小写
   */
  mtn = 'mtn',
  MTN = 'MTN',
  /** 一物一码中的campaingnId */
  campaignId = 'campaignid',
  /** 活动type,用于标记某类活动便于展示对应模块 */
  actType = 'actType',
  /** 推广员场景-活动id */
  promoterActId = 'promoterActId',
  /** 推广员场景-推广码 */
  promoterCode = 'promoterCode',
  /** 维他奶cdkey抽奖活动 */
  cdkey = 'cdkey',
}

/**
 * 本页面统一从url模块获取qryParams，便于管理
 */
export const getUrlParamByKey = (paramKey: UrlParamKey) => url.getUrlParam(paramKey) || '';
